export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS';
export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
export const UPDATE_CUSTOMER_DETAILS = 'UPDATE_CUSTOMER_DETAILS';

export const DOWNLOAD_CUSTOMER_CSV = 'DOWNLOAD_CUSTOMER_CSV';
export const DOWNLOAD_CUSTOMER_CSV_FAILURE = 'DONWLOAD_CUSTOMER_CSV_FAILURE'
export const DOWNLOAD_CUSTOMER_CSV_SUCCESS = 'DOWNLOAD_CUSTOMER_CSV_SUCCESS'

export const GET_CUSTOMER_TRANSACTION = 'GET_CUSTOMER_TRANSACTION'
export const GET_CUSTOMER_TRANSACTION_FAILURE = 'GET_CUSTOMER_TRANSACTION_FAILURE'
export const GET_CUSTOMER_TRANSACTION_SUCCESS = 'GET_CUSTOMER_TRANSACTION_SUCCESS'